<div class="container-fluid line-item-list shopping-cart">
  <!-- Line Items Overview -->
  <div class="row list-heading py-2 mt-2 d-none d-md-flex border-bottom">
    <div class="col-md-6 col-xl-5" [ngClass]="{ ' pl-0': editable() }">
      {{ 'shopping_cart.product_description.dias.heading' | translate }}
    </div>
    <div class="col-md-2 col-xl-2">
      {{ 'shopping_cart.price.heading' | translate }}
    </div>
    <div class="col-md-2 col-xl-2 qty-display-property">
      {{ 'shopping_cart.qty.heading' | translate }}
    </div>
    <div class="col-md-2 col-xl-2 column-price">
      {{ 'shopping_cart.subtotal.dias.heading' | translate }}
    </div>
    @if ((editable())) {
    <div class="col-md-2 col-xl-1 list-header-action" [ngClass]="{ 'pr-0': editable() }">
      {{ 'shopping_cart.action.dias.heading' | translate }}
    </div>
    }
  </div>

  @for (pli of displayItems; track trackByFn(i, pli); let i = $index) {
  <ish-line-item-list-element
    ishProductContext
    [sku]="pli.productSKU"
    [quantity]="pli.quantity.value"
    [allowZeroQuantity]="true"
    [pli]="pli"
    [lineItemViewType]="lineItemViewType()"
    [editable]="editable() && pli.editable"
  />

  }

  <div class="mt-4">
    @if (showPagingBar) {
    <div class="row">
      <div
        class="col-12 d-flex grey-panel align-items-center flex-column flex-md-row justify-content-between px-3 py-2 mb-3"
      >
        <span>{{ 'shopping_cart.paging.items.label' | translate : { '0': lineItems().length } }}</span>
        <ish-paging [currentPage]="currentPage" [lastPage]="lastPage" (goToPage)="goToPage($event)" />
      </div>
    </div>
    }
  </div>
  @if (total()?.value && lineItems().length > 0) {
  <div class="clearfix section">
    <div class="row justify-content-end list-body">
      <div class="col-sm-4 col-md-3 col-lg-2 text-right pr-0">{{ 'quote.items.total.label' | translate }}</div>
      <div class="col-sm-4 col-md-2 pr-0">
        <div class="total-price text-right">{{ total() | ishPrice }}</div>
      </div>
    </div>
  </div>
  }
</div>
